import React from 'react'
import styled from '@emotion/styled'
import {theme} from '../../features/Dashboard/theme'
import {
  PTAcceptedSVG,
  PTCalender2SVG,
  PTCompletedSVG,
  PTCrossCircleSVG,
  PTDraftSVG,
  PTSentSVG,
} from '../../../../assets'

const STATUS_ICONS = {
  Sent: PTSentSVG,
  Viewed: PTAcceptedSVG,
  Completed: PTCompletedSVG,
  Draft: PTDraftSVG,
  Declined: PTCrossCircleSVG,
  Expired: PTCalender2SVG,
}

const BadgeWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 12px;
  border-radius: ${theme.radius.full};
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  background: ${props =>
    (theme.colors.status[props.status] || {}).bg || theme.colors.hover};
  color: ${props =>
    (theme.colors.status[props.status] || {}).color || theme.colors.muted};
`

function StatusBadge({status}) {
  const Icon = STATUS_ICONS[status]
  return (
    <BadgeWrapper status={status}>
      {Icon && <Icon width="12" height="12" />}
      {status}
    </BadgeWrapper>
  )
}

export {StatusBadge}
